@if (me) {
  <div class="header-wrapper">
    <div class="upper-row">
      <div class="upper-buttons clearfix">
        <button class="support-button" (click)="mailToSupport()">
          <i class="far fa-question-circle support-button-icon"></i>
          <ng-container i18n>Support</ng-container>
        </button>
        <button registerMenuToggle class="user-button" (clickedOutside)="isMenuOpen = false" (click)="isMenuOpen = !isMenuOpen">
          @if (me.photo !== null) {
            <img src="{{ me.photo }}" alt="" />
          } @else {
            <span>
              <i class="fal fa-user no-user-photo"></i>
            </span>
          }
          {{ me.firstName }} {{ me.lastName }} <i class="fas fa-chevron-down user-button-icon"></i>
        </button>
      </div>
    </div>
    <div class="lower-row">
      <div class="header-selection" [class.closed]="!isMenuOpen">
        <button class="selection-button profile-button" (click)="navigateToProfile(me.id)" i18n>My profile</button>
        <button class="selection-button logout-button" (click)="logout()" i18n>Logout</button>
      </div>
    </div>
  </div>
}
